import ProductCardInfo from './ProductCardInfo';

export default ProductCardInfo;
